export default "__VITE_ASSET__eac04705__"